/* Tour "scenarios" (chapitre back « add_scenario » — Créez un scénario).

   Le scénario de démo « Augmentation du CA (démo) » est CRÉÉ AU DÉMARRAGE avec
   DEUX événements déjà présents :
     - « Recrutement d'un commercial »  → −2 500 €/mois, dès maintenant (la cause)
     - « Augmentation des ventes »      → +5 000 €/mois, à partir de +2 mois (l'effet)
   (le signe vient du montant ; la catégorie est cosmétique). La chronologie
   raconte : d'abord on recrute, deux mois plus tard les ventes augmentent.

   Le tuto : ouvre le panneau, ouvre l'événement « recrutement » (la cause) pour
   en montrer les paramètres, présente l'événement « ventes » (l'effet, +2 mois),
   puis visualise l'impact. Tout (scénario + événements) est supprimé au onExit. */

import AppBus from '@/bus/app-bus';
import './types';

const DEMO_SCENARIO_NAME = 'Augmentation du CA (démo)';

window.FygrTour.register('scenarios', {
  title: 'Créer un scénario',
  page: '/dashboard',
  intro: {
    title: 'Créer un scénario',
    body: 'Un scénario teste des hypothèses sans toucher à votre prévisionnel réel. Nous avons préparé un scénario d’exemple « Augmentation du CA » avec deux événements : le recrutement d’un commercial, puis la hausse des ventes qu’il génère deux mois plus tard.',
    note: 'C’est une démonstration : le scénario d’exemple et ses événements seront supprimés à la fin du tutoriel.',
    startLabel: 'Commencer',
    optoutLabel: 'Désactiver les guides automatiques',
    optoutNote: 'Ils ne s’afficheront plus automatiquement. Vous pourrez les relancer à tout moment depuis « Tutoriels ».',
  },
  onStart: () => {
    // Le moteur a pu naviguer vers /dashboard → le Dashboard se monte après. On
    // émet en rafale ; la garde anti-doublon côté Dashboard évite les créations
    // multiples. On force aussi la vue tableau (l'impact s'y lit).
    let tries = 0;
    const tick = () => {
      AppBus.$emit('tour:seed-scenario', DEMO_SCENARIO_NAME);
      AppBus.$emit('tour:dashboard-table');
      if (++tries < 10) setTimeout(tick, 500);
    };
    tick();
  },
  onExit: () => {
    AppBus.$emit('tour:cleanup-scenario', DEMO_SCENARIO_NAME);
  },
  steps: [
    {
      target: '[data-tour-step="dash-scenario"]',
      title: 'Ouvrez vos scénarios',
      body: 'Cliquez sur « Scénario » pour ouvrir votre espace de scénarios. Le scénario d’exemple « Augmentation du CA » vous y attend.',
      placement: 'bottom',
      clickToAdvance: true,
      waitFor: '[data-tour-step="demo-ev-hire-edit"]',
      waitTimeout: 10000,
    },
    {
      target: '[data-tour-step="demo-ev-hire-edit"]',
      title: 'Le premier événement',
      body: 'Tout commence par « Recrutement d’un commercial » : une charge (−2 500 €/mois) que vous engagez dès maintenant. Ouvrez-le pour voir sa configuration.',
      placement: 'left',
      strictTarget: true,
      // L'éditeur s'ouvre au clic sur l'icône « éditer » → on avance dès qu'il
      // apparaît (robuste au rendu).
      advanceWhen: '[data-tour-step="event-editor"]',
      waitTimeout: 8000,
    },
    {
      target: '[data-tour-step="cfs-valeur"]',
      title: 'Le montant',
      body: 'Son montant : −2 500 € (une sortie, car le montant est négatif).',
      placement: 'left',
      lockTarget: true,
      clickToAdvance: false,
      waitTimeout: 8000,
    },
    {
      target: '[data-tour-step="cfs-recurrence"]',
      title: 'La récurrence',
      body: 'Il se répète chaque mois : c’est une charge récurrente, pas un événement ponctuel.',
      placement: 'left',
      lockTarget: true,
      clickToAdvance: false,
      groupWithPrevious: true,
    },
    {
      target: '[data-tour-step="cfs-category"]',
      title: 'La catégorie',
      body: 'Et il est rattaché à une catégorie pour se projeter au bon endroit dans votre trésorerie.',
      placement: 'left',
      lockTarget: true,
      clickToAdvance: false,
      groupWithPrevious: true,
      // Ferme l'éditeur SEUL (le panneau reste ouvert) pour revenir à la liste
      // et présenter le second événement (« ventes »).
      onNext: () => AppBus.$emit('tour:close-event-editor'),
    },
    {
      target: '[data-tour-step="demo-ev-sales"]',
      title: 'Le second événement',
      body: 'Deux mois après ce recrutement, « Augmentation des ventes » : la hausse de revenus (+5 000 €/mois) que votre commercial génère.',
      placement: 'left',
      lockTarget: true,
      strictTarget: true,
      clickToAdvance: false,
      waitTimeout: 5000,
      // Ferme le panneau avant l'overview : on ne voit que le tableau, et la
      // pop-up ne réapparaît pas au Terminer.
      onNext: () => AppBus.$emit('tour:close-scenario-editor'),
    },
    {
      target: '.cash-wrapper',
      title: 'Visualisez l’impact',
      body: 'Votre scénario projette les deux événements dans le tableau : d’abord le coût du commercial, puis la hausse des ventes qu’il génère 2 mois plus tard. Le tout sans toucher à votre prévisionnel réel.',
      placement: 'top',
      lockTarget: true,
      clickToAdvance: false,
      waitTimeout: 5000,
    },
  ],
  celebration: {
    title: 'Votre premier scénario',
    body: 'Vous savez lire un scénario et ses événements pour tester vos hypothèses. Le scénario d’exemple de cette démonstration a été retiré.',
  },
});

export {};
